import Backbone from 'backbone';
import $ from 'jquery';
import _ from 'underscore';

import * as AssemblyModels from 'assembly/AssemblyModels';
import SingleFragmentWizard from 'assembly/SingleFragmentWizard';
import * as AssemblyConstants from 'constants/AssemblyConstants';

const {ASSEMBLY_TYPE} = AssemblyConstants;

import ModelTypeConstants from 'constants/ModelTypeConstants';
import FileStates from 'FileStates';

const fileStates = FileStates.get();
const {assemblies} = AssemblyModels;

class WizardContainer extends Backbone.View {
  static initClass() {
    this.prototype.el = '#assembly-wizard-container';

    this.prototype.WIZARD_TYPES = _.object([
      [ASSEMBLY_TYPE.DIGEST, SingleFragmentWizard],
      [ASSEMBLY_TYPE.GIBSON, SingleFragmentWizard],
      [ASSEMBLY_TYPE.GOLDEN_GATE, SingleFragmentWizard],
    ]);
  }

  initialize() {
    this.view = null;
    this.listenTo(assemblies, 'change:active change:slots add remove', this.updateAssembly);
    this.listenTo(fileStates, 'change:active add remove reset', this.updateAssembly);
  }

  hideWizard() {
    $('#editor').removeClass('has-assemblyWizard').removeClass('has-assemblyWizard-info');
    $(window).trigger('buffersResize');
    this.$el.addClass('hidden');
  }

  updateAssembly() {
    if (this.view != null) {
      this.view.remove();
      this.view = null;
    }

    const assembly = assemblies.findWhere({active: true});
    const isSequenceFileActive =
      fileStates.find(
        (fileState) => fileState.active() && fileState.fileType() === ModelTypeConstants.SEQUENCE
      ) != null;
    if (assembly == null || !isSequenceFileActive) {
      this.hideWizard();
      return;
    }
    const WizardType = this.WIZARD_TYPES[assembly.method()];
    this.view = new WizardType({model: assembly, sequence: this.sequence});
    this.$el.append(this.view.render().el);
    this.$el.removeClass('hidden');

    // Trigger 'opened' when an assembly is rendered to allow help tour to start
    assembly.trigger('opened');
  }

  update(fileState) {
    if (
      (fileState != null ? fileState.fileType() : undefined) === ModelTypeConstants.SEQUENCE &&
      fileState.model().type() !== 'oligo'
    ) {
      this.sequence = fileState.model();
    } else {
      this.sequence = null;
    }
    if (this.view != null) {
      this.view.updateSequence(this.sequence);
    }
  }
}
WizardContainer.initClass();

export default WizardContainer;
